import { PolicyDetails } from './policy-details.model';
import { CoverageContainer, TripDetails } from './../../shared';
import { TravelersData } from './travelers-data.model';
import { FlightDataContainer } from './flights-data.model';
import { Rules, State } from '@bhtp-client-api/eligibility';
import { ApiQuoteRequest, ApiQuoteResponse } from '@bhtp-client-api/base';
import { ApiPolicyEditResponse, ApiPolicyGetForEditResponse } from '@bhtp-client-api/edit';
import { TravelerDetailViewConfig, AddressViewConfig, FieldConfigs } from '@bhtp-client-web/component';
import { BillingInformation } from './../../shared/models/index';
import { PolicyFlightOverride } from '@bhtp-client-web/component';

export class EditContainerData {
    // Edit Data
    public policyNumber: string;
    public policyDetails: PolicyDetails;
    public tripDetails: TripDetails;
    public coverageContainer: CoverageContainer;
    public policyTravelers: TravelersData;
    public flightData: FlightDataContainer;
    public billingData: BillingInformation;

    // Rules Data
    public rules: Rules;
    public fieldConfigs: FieldConfigs;
    public addressConfig: AddressViewConfig;
    public newTravelerConfig: TravelerDetailViewConfig;
    public canAddTravelers: boolean = false;
    public canRemoveTravelers: boolean = false;
    public showTripCostDetails: boolean = true;
    public showDestinationDetails: boolean = true;

    // States Data
    public states: Array<State>;

    // Quoting Data
    /**
     * The original policy data, to be edited.
     */
    public policyResponse: ApiPolicyGetForEditResponse;
    public freshQuote: ApiQuoteResponse;
    public coverageQuote: ApiQuoteResponse;
    public quoteRequest: ApiQuoteRequest;
    public editRequest: ApiPolicyGetForEditResponse;
    public editResponse: ApiPolicyEditResponse;

    // Flight Reminder
    public flightReminderPolicy: PolicyFlightOverride;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/view-models/edit-container-data.ts